export default __webpack_public_path__ + "static/media/MilknBalls-BlackDemo-3.d0285898.ttf";